import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=24b90038&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=24b90038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b90038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b90038')) {
      api.createRecord('24b90038', component.options)
    } else {
      api.reload('24b90038', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=24b90038&scoped=true&", function () {
      api.rerender('24b90038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XxwAyTtv83ZE/JS/comp/DateRangeExt.vue"
export default component.exports